import TableCell from './TableCell';
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    backgroundColor: "#EDF0F2"
  }
})(TableCell);